import { format } from "date-fns";
import { formatarComoDecimal, formatarComoMoeda, formatarMoeda2, parseLocaleNumber, retornaDescricaoConta } from "../../contents/VariaveisGlobais";
import { handleFilaAprovadores } from "./Pedido";
import { handleAbrirPC } from "./Solicitacao";
import { CelBreak, CelBreak15, CelBreak25, NormalFont } from "./styles";
import SelectArmazem from "../Select/Armazem";
import SelectCentroCusto from "../Select/CentroCusto";
import SelectContaContabil from "../Select/ContaContabil";
import InputGeral from "../InputGeral/Index";
import $ from "jquery";

function handleFilialContratoParceria(item, DisparaBootBox, FechaBootBox, navigate){
    const { C3_NUM, EMPRESA, C3_FILIAL } = item.row.original;
    const chaveSCR = C3_NUM

    return (
        <>
            <NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("CP", chaveSCR, EMPRESA, C3_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{C3_FILIAL}</NormalFont>
            <br/><NormalFont><strong>CP: </strong>{C3_NUM}</NormalFont>
        </>
    )
}

function handleStatusCP(item){ 
    const { C3_CONAPRO, C3_DATPRF } = item.row.original
    const currentDate = new Date()
    const cStatus = ( Number(C3_DATPRF) < Number(format(currentDate, 'yyyyMMdd')) ? 'Vencido' : 'Liberado')

    return C3_CONAPRO === 'B' ? 'Em Aprovação' : ( C3_CONAPRO == 'R' ? 'Rejeitado' : cStatus )
}

function handleFornecedorCPColumn(item){
    const { C3_LOJA, A2_NOME, Y1_COD, Y1_NOME, C3_COND, E4_DESCRI } = item.row.original;

    return ( 
        <>
            <CelBreak>
                <strong>{item.value.trim()}/{C3_LOJA}</strong> - {A2_NOME.trim()}
            </CelBreak>
            { Y1_NOME && Y1_NOME.trim() && (
                <CelBreak>
                    <strong>Comprador: </strong>{Y1_COD + ' - ' + Y1_NOME}
                </CelBreak>
            )} 
            { E4_DESCRI && E4_DESCRI.trim() && (
                <CelBreak>
                    <strong>Cond. Pagto: </strong>{C3_COND + ' - ' + E4_DESCRI}
                </CelBreak>
            )}            
        </>
    )
}

function handleProdutoCPColumn(item){
    const { DESCRI, C3_XCA, C3_OBS } = item.row.original

    return ( 
        <CelBreak25>
            <strong>{item.value.trim()}</strong> - {DESCRI.trim()}
            { C3_OBS.trim() && (<p><strong>Desc. Complementar: </strong>{C3_OBS}</p> ) }
            { C3_XCA.trim() && (<p><strong>CA: </strong>{C3_XCA}</p> ) }
        </CelBreak25> 
    )
}

function handleSaldoCPColumn(item, data, setData){
    const {C3_NUM, C3_ITEM, C3_PRECO, C3_TOTAL, C3_QUANT, C3_QUJE} = item.row.original
    const indexData = item.row.index
    const unitario = formatarComoMoeda(C3_PRECO, 2)
    const total = formatarComoMoeda(C3_TOTAL,2)
    const saldoAux = parseFloat(C3_QUANT) - parseFloat(C3_QUJE)
    const saldo = formatarMoeda2(saldoAux,2);

    return ( <CelBreak15>
        <strong>Qtd.: </strong>
        <InputGeral 
            idComponente={`QTD_${C3_NUM}_${C3_ITEM}`}
            tipo="monetario"
            decimal={2}            
            onChange={(e, value) => { handleChangeDataCP(e, value, indexData, data, setData, "Quantidade Selecionada") }}
            placeholder="Quantidade"
            valueNoUpdate={saldo}            
        />
        <br/><strong>Qtd. Saldo: </strong>{saldo}
        <br/><strong>Unitário: </strong>{unitario}
        <br/><strong id={`TOTAL_${C3_NUM}_${C3_ITEM}`}>Total: {total} </strong>
    </CelBreak15> )
}

function handleArmazemCP(item, data, setData, empresaFilial){
    const {C3_NUM, C3_ITEM, CC, CONTA, C3_CC, C3_LOCAL } = item.row.original
    const indexData = item.row.index

    return ( <CelBreak25>
        <strong>Armazém: </strong>
        <SelectArmazem
            label=""
            idComponente={`ARM_${C3_NUM}_${C3_ITEM}`}
            {...(C3_CC && C3_CC.trim() && { campoLocalEstoque: item.row.original.LOCAL })}
            filtraFilial={true}
            returnOriginal={true}
            showNoFilter={true}
            empresaLogada={empresaFilial}  
            changeLocalEstoque={(e) => { handleChangeDataCP(e, "", indexData, data, setData, "Armazem");}}     
            disabled={C3_CC && C3_CC.trim()}
        />
        <br/><strong>CC: </strong><span id={`CC_${C3_NUM}_${C3_ITEM}`}>{CC?.label.trim()}</span>
        <br/><strong>Conta: </strong><span id={`CNT_${C3_NUM}_${C3_ITEM}`}>{CONTA?.label?.trim()}</span>        
    </CelBreak25> )
}

async function handleChangeDataCP(e, valor, indexData, data, setData, field){    
    const CTT_XTIPO     = e?.origem?.CTT_XTIPO
    const CTT_DESC01    = e?.origem?.CTT_DESC01
    const NNR_XCC       = e?.origem?.NNR_XCC
    const CTT_CEP       = e?.origem?.CTT_CEP
    const CTT_ENDER     = e?.origem?.CTT_ENDER
    const CTT_BAIRRO    = e?.origem?.CTT_BAIRRO
    const CTT_MUNIC     = e?.origem?.CTT_MUNIC
    const CTT_ESTADO    = e?.origem?.CTT_ESTADO

    const newData = await Promise.all( data.map( async(itensCP, index) => { 
        if (index === indexData ){
            switch (field) {
                case "Quantidade Selecionada":
                    const saldo = parseFloat(itensCP.C3_QUANT) - parseFloat(itensCP.C3_QUJE)
                    
                    itensCP.QTDSEL = formatarMoeda2(valor,2);
                    if (saldo < parseFloat(valor)){
                        itensCP.QTDSEL = formatarMoeda2(saldo,2);
                    }
                    
                    const total = ( Number(parseLocaleNumber(itensCP.QTDSEL)) * Number(itensCP.C3_PRECO) ) 
                    
                    itensCP.TOTAL = formatarMoeda2(total,2);

                    $(`#QTD_${itensCP.C3_NUM}_${itensCP.C3_ITEM}`)[0].value = itensCP.QTDSEL
                    $(`#TOTAL_${itensCP.C3_NUM}_${itensCP.C3_ITEM}`)[0].innerText = 'Total: ' + formatarComoMoeda(total,2)
                    break
                case "Armazem":
                    itensCP.LOCAL = e;                        
                    
                    let contaProduto = (CTT_XTIPO === "2" ? itensCP.CNTPROD[0].operacional : itensCP.CNTPROD[0].corporativo).trim()                    
                    let contaFinalidadeGrupo = itensCP.CNTPROD.filter( (itemContabil) => itemContabil.finalidade === itensCP.C3_XTIPCOM )
                    contaProduto = contaProduto ? contaProduto : ( contaFinalidadeGrupo.length > 0 ? ( CTT_XTIPO === "2" ? contaFinalidadeGrupo[0].operacional : contaFinalidadeGrupo[0].corporativo ) : "" ).trim()
                    const descricaoProduto = await retornaDescricaoConta(contaProduto)

                    itensCP.CC = {value: NNR_XCC, label: NNR_XCC?.trim() + ' - ' + CTT_DESC01?.trim() }
                    itensCP.CONTA = {value: contaProduto.trim(), label: contaProduto.trim() + ' - ' + descricaoProduto }
                    itensCP.ENTREGA = CTT_CEP + ' - ' + CTT_ENDER + ', ' + CTT_BAIRRO + ' - ' +  CTT_MUNIC + '/' + CTT_ESTADO

                    $(`#CC_${itensCP.C3_NUM}_${itensCP.C3_ITEM}`)[0].innerText = itensCP.CC.label
                    break;
                default:
                    break;
            }
        }
        
        return itensCP
    } ) )

    setData(newData)
}

export { handleFilialContratoParceria, handleFornecedorCPColumn, handleStatusCP, handleProdutoCPColumn, handleSaldoCPColumn, handleArmazemCP }